import type { ReportDescriptionListParams } from '../types'

export const DEFAULT_REPORT_DESCRIPTION_LIST_PARAMS: ReportDescriptionListParams = {
  orderBy: 'report_name',
  sortBy: 'asc',
}

/** Matches Angular `emptydata.component.html` (`app-emptydata`). */
export const EMPTY_LIST_MESSAGE =
  'No Records Found. Please try a different Search or Filter from the drop-downs above.'
